import { MenuItem } from "@/types/menu";
import { UserRole } from "@/types/user-role";
import {
  Home,
  MailPlus,
  MessageCircleIcon,
  Settings,
  Store,
  Users,
} from "lucide-react";

export const navItems: MenuItem[] = [
  {
    title: "Dashboard",
    path: "/app/dashboard",
    icon: Home,
    roles: [UserRole.ADMIN, UserRole.MEMBER],
  },
  {
    title: "Conversas",
    path: "/app/chats",
    icon: MessageCircleIcon,
    roles: [UserRole.ADMIN, UserRole.MEMBER],
  },
  {
    title: "Usuários",
    path: "/app/users",
    icon: Users,
    roles: [UserRole.ADMIN],
  },
  {
    title: "Convites",
    path: "/app/invitations",
    icon: MailPlus,
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
  },
  {
    title: "Organizações",
    path: "/app/organizations",
    icon: Store,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    title: "Configurações",
    path: "/app/settings",
    icon: Settings,
    roles: [UserRole.MEMBER, UserRole.ADMIN],
  },
];
